import { IAPITotalAppointments, ITotalAppointments } from './ITotalAppointments'

class Transformer {
    static transform(appointment: IAPITotalAppointments): ITotalAppointments {
        return {
            onlineAppointments: appointment.online_appointments,
            phoneAppointments: appointment.phone_appointments,
            walkInAppointments: appointment.walk_in_appointments,
        }
    }
}

export default Transformer
